import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})

export class LoggerService {

    logLevel: 'debug' | 'info' | 'warn' | 'error' =  environment.logLevel as 'debug' | 'info' | 'warn' | 'error';

    constructor() {
        const envType = environment.production ? 'PRODUZIONE' : 'SVILUPPO';
        console.log(`%c🔥 LoggerService attivo in ambiente: ${envType}`, 'color: orange; font-weight: bold;');
        console.log(`%c🔹 Livello di log attuale: ${this.logLevel}`, 'color: cyan; font-weight: bold;');
    }

    setLogLevel(level: 'debug' | 'info' | 'warn' | 'error'): void {
        this.logLevel = level;
    }

    private canLog(level: 'debug' | 'info' | 'warn' | 'error'): boolean {
        const levels = ['debug', 'info', 'warn', 'error'];
        return levels.indexOf(level) >= levels.indexOf(this.logLevel);
    }

    debug(message: string, data?: any): void {
        if (this.canLog('debug')) {
            console.log(`%cDEBUG - ${message}`, 'color: #1df578;', data);
        }
    }

    info(message: string, data?: any): void {
        if (this.canLog('info')) {
            console.log(`%cINFO - ${message}`, 'color: #1d9af5;', data);
        }
    }

    action(message: string, data?: any): void {
        if (this.canLog('warn')) {
            console.warn(`%cACTION - ${message}`, 'color: #f5e41d;', data);
        }
    }
    
    error(message: string, data?: any): void {
        console.error(`%c*ERROR* - ${message}`, 'color: #f51d2e; font-weight: bold;', data);
    }

    formatMessage(message: string, level: string): string {
        const timestamp = new Date().toISOString();
        return `[${timestamp}] ${level.toUpperCase()}: ${message}`;
    }

}